import { Pipe, PipeTransform } from '@angular/core';
export class CharactersPipe implements PipeTransform {
/**
 * @param {?} value
 * @param {?=} args
 * @param {?=} breakOnWord
 * @return {?}
 */
transform(value: string, args: number = 10, breakOnWord?: boolean): string {
    let /** @type {?} */ res = value;
    if (value && value.length > args && args > 0) {
      value = value.substring(0, args);

      if (breakOnWord) {
        while (value.charAt(value.length - 1) === ' ') {
          value = value.substr(0, value.length - 1);
        }
      } else {
        const /** @type {?} */ lastspace = value.lastIndexOf(' ');
        // get last space
        if (lastspace !== -1) {
          value = value.substr(0, lastspace);
        }
      }
      res = `${value}...`;
    }
    return res;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'characters'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CharactersPipe_tsickle_Closure_declarations() {
/** @type {?} */
CharactersPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CharactersPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
